import isEmpty from "lodash-es/isEmpty";
import { type ActorRefFromLogic } from "xstate";

import { docsApi } from "~/state/api/docsapi";
import { type PermRelation } from "~/state/types";
import { LOCAL_WORKSPACE_NAME } from "~/strings";

import { type AuthenticationMachine, getAccessToken } from "../authentication";

export const setRepoPublished = async ({
	input: {
		type,
		relation,
		publishWorkspace: workspaceName,
		documentId,
		authenticationActorRef,
		skip,
	},
}: {
	input: {
		type: "grant" | "revoke";
		relation: PermRelation;
		publishWorkspace: string;
		documentId: string;
		authenticationActorRef: ActorRefFromLogic<AuthenticationMachine>;
		skip: boolean;
	};
}) => {
	if (skip) {
		return;
	}

	if (isEmpty(workspaceName)) {
		throw new Error("Workspace name is required to set repo published state");
	}
	if (workspaceName === LOCAL_WORKSPACE_NAME) {
		throw new Error("Cannot publish a document to the `local` workspace");
	}

	const token = await getAccessToken(authenticationActorRef);
	if (!token) {
		return;
	}
	await docsApi.document.permissions.updatePublicAccess({
		token,
		type,
		workspaceName,
		documentId,
		relation,
	});
};
